import React from "react";
import { DataNotFound } from "../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import ReviewAttribute from "../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import { toTitleCase } from "../../../Utils/stringUtls";

const CooperativeAuthenticationOverview = ({ data }) => {
  if (!data) return <DataNotFound />;

  const {
    cooperative_authentication_would_you_like_opt_for_cooperative_authorization_with_i2c,
    cooperative_authentication_please_confirm_if_client_would_like_to_maintain_the_balances_and_will_be_the_system_of_records,
    cooperative_authentication_who_is_providing_core_banking_services,
  } = data["7_0"];

  return (
    <React.Fragment>
      <div className="forms-instance" style={{ color: "#111" }}>
        <div i2c-grid="grid grid" className="review-summary-gap">
          <div i2c-grid="12@md" className="review-summary-sub-heading">
            <div className="fw-700 font-bold">Opting for Cooperative Authentication</div>
          </div>
          <ReviewAttribute
            label="Would you like to opt for Cooperative (mutual) Authorization with i2c?"
            value={cooperative_authentication_would_you_like_opt_for_cooperative_authorization_with_i2c?.length ? toTitleCase(cooperative_authentication_would_you_like_opt_for_cooperative_authorization_with_i2c) : "-"}
          />
          {cooperative_authentication_would_you_like_opt_for_cooperative_authorization_with_i2c === "yes" && (
            <>
              <ReviewAttribute
                label="Please confirm if client would like to maintain the balances and will be the system of record?"
                value={cooperative_authentication_please_confirm_if_client_would_like_to_maintain_the_balances_and_will_be_the_system_of_records?.length ? toTitleCase(cooperative_authentication_please_confirm_if_client_would_like_to_maintain_the_balances_and_will_be_the_system_of_records) : "-"}
              />
              <ReviewAttribute
                label="Who is providing core banking services?"
                value={cooperative_authentication_who_is_providing_core_banking_services?.length ? cooperative_authentication_who_is_providing_core_banking_services : "-"}
              />
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CooperativeAuthenticationOverview;
